import React from 'react';
import {  Show,
ShowButton,List,EditButton,SimpleForm,
 Datagrid,RichTextInput,DisabledInput,TextInput,Edit,
TextField, RichTextField ,SimpleShowLayout,
ReferenceInput, SelectInput,DateField
 }
from 'admin-on-rest/lib/mui';

export const FraudList = (props) => (
    <List perPage={30} title="הונאה" {...props}>
        <Datagrid>
            <TextField label="#" source="id" />
            
            
            <TextField label="שם בית עסק" source="buisiness_name" />
            <TextField label="חברת אשראי" source="cc_company" />
            <TextField label="מספר כרטיס" source="card_number" />
            <DateField label="תאריך עסקה" source="iska_date.date" locales="he-IL"/>
            <TextField label="סכום תנועה" source="iska_total" />       
            <TextField label="סכום תנועת מקור" source="original_iska_total" />
            <TextField label="זיהוי המסוף" source="masof" />
            <TextField label="סוג הונאה" source="fraud_type" />
            <TextField label="קוד הונאה" source="fraud_code" />
            <DateField label="תאריך הפקדה" source="hafaka_date.date" locales="he-IL"/>
            <TextField label="source_file" source="source_file"/>
            <ShowButton />
        </Datagrid>
    </List>
);

const PostTitle = ({ record }) => {
    return <span> {record ? `${record.id}` : ''}</span>;
};


export const FraudShow = (props) => (

<Show title={<PostTitle />} {...props}>
 <SimpleShowLayout>
        <TextField label="#" source="id" />
            <TextField label="סוג רשומה" source="recordType" />
            <TextField label="מזהה רשת" source="external_id" />
            <TextField label="מזהה בית עסק" source="buisiness_id" />
            <TextField label="שם בית עסק" source="buisiness_name" />
            <TextField label="מיקום בית עסק" source="buisiness_location" />
            <TextField label="ארץ בית עסק" source="buisiness_country" />
            <TextField label="מיקוד בית עסק" source="buisiness_zip" />
            <TextField label="חברת אשראי" source="cc_company" />
            <TextField label="BIN מקבל" source="bin_reciever" />
            <TextField label="BIN שולח" source="bin_sender" />
            <TextField label="ARN" source="arn" />
            <TextField label="מספר כרטיס" source="card_number" />
            <TextField label="מיקוד בעל כרטיס" source="card_owner_zip" />
            <TextField label="תאריך עסקה" source="iska_date" />
            <TextField label="סכום תנועה" source="iska_total" />
            <TextField label="קוד מטבע ISO נומרי" source="currency" />
            <TextField label="סכום תנועת מקור" source="original_iska_total" />
            <TextField label="זיהוי המסוף" source="masof" />
            <TextField label="קוד ענף" source="kod_anaf" />
            <TextField label="שיטת ביצוע ב-POS" source="shitat_bizua" />
            <TextField label="סוג הונאה" source="fraud_type" />
            <TextField label="קוד הונאה" source="fraud_code" />
            <TextField label="תאריך הפקדה" source="hafaka_date" />
            <TextField label="אינדיקציה ל-CHB" source="chb_indication" />
            <TextField label="תאריך דיווח" source="divuach_date" />
            <TextField label="תאריך שיגור" source="shigur_date" />
            <TextField label="source_file" source="source_file" />
            

         </SimpleShowLayout>
    </Show>
);

       
         





              



// WEBPACK FOOTER //
// ./src/components/Fraud/frauds.js